
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V18.5","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.268 28.733a2.5 2.5 0 11-3.535 3.536 2.5 2.5 0 013.535-3.536z","fill":"#FFC74A"}}),_c('path',{attrs:{"d":"M28.268 28.733a2.5 2.5 0 11-3.535 3.536 2.5 2.5 0 013.535-3.536","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.268 23.733a2.5 2.5 0 11-3.536 3.536 2.5 2.5 0 013.536-3.536z","fill":"#86CEFC"}}),_c('path',{attrs:{"d":"M38.268 23.733a2.5 2.5 0 11-3.536 3.536 2.5 2.5 0 013.536-3.536","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.268 33.733a2.5 2.5 0 11-3.536 3.536 2.5 2.5 0 013.536-3.536z","fill":"#86CEFC"}}),_c('path',{attrs:{"d":"M38.268 33.733a2.5 2.5 0 11-3.536 3.536 2.5 2.5 0 013.536-3.536M28.725 29.386l5.55-2.775M28.725 31.616l5.55 2.775M14.671 14.672h15.007M14.671 21.834h6.67M14.671 28.834h5.003","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    